import { render } from "./ProvidersTable.vue?vue&type=template&id=dc6a6236"
import script from "./ProvidersTable.vue?vue&type=script&lang=js"
export * from "./ProvidersTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__